import htmx from "htmx.org";
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import { setCookie } from "./utils/helpers.js";

// Components
import { initHeaderAnimations } from "./components/header.js";
import { initCarousel } from "./components/carousels.js";
import { initDialogs } from "./components/dialogs.js";
import { initSelectWidget } from "./components/widgets.js";
import { initScrollAnimations } from "./components/scroll-animations.js";
// import { initScrollSpy } from "./components/scroll-spy.js";
import { initSearchForm, initHtmxCallbacks } from "./components/search.js";

/**
 * Setup global libraries
 */
function setupGlobals() {
	// Make htmx globally available
	window.htmx = htmx;

	// Configure htmx scroll behavior
	htmx.config.scrollBehavior = "smooth";

	// Make setCookie globally available for Alpine.js
	window.setCookie = setCookie;

	// Register Alpine plugins
	Alpine.plugin(collapse);
	Alpine.plugin(focus);

	// Make Alpine globally available and start it
	window.Alpine = Alpine;
	Alpine.start();
}

/**
 * Initialize all components
 */
function init() {
	setupGlobals();

	initCarousel();
	initDialogs();
	initHeaderAnimations();
	// initHtmxCallbacks();

	initSearchForm();
	initSelectWidget();

	// Uncomment when needed
	// initScrollSpy();
	// initStickySideNav();
	initScrollAnimations();
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
